import https from "./https";

export const checkStatus = async txRef => {
    try {
        return await https.post("/widget/check-status", { txRef })
    } catch (err) {
        throw err;
    }
}